import { NavLink } from "@/components/NavLink";
import { useTranslation } from "react-i18next";
import { Home, BookOpen, Zap, Spade, User } from "lucide-react";
import { cn } from "@/lib/utils";

export const BottomNav = () => {
  const { t } = useTranslation();

  const navItems = [
    { id: "quick", label: t("nav_minigames"), icon: Zap, path: "/minigames" },
    { id: "learn", label: t("nav_learn"), icon: BookOpen, path: "/learn" },
    { id: "home", label: t("nav_home"), icon: Home, path: "/home", isHero: true },
    { id: "play", label: t("nav_play"), icon: Spade, path: "/play" },
    { id: "profile", label: t("nav_profile"), icon: User, path: "/profile" },
  ];

  return (
    <nav aria-label="Main navigation" className="fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-md border-t border-white/[0.06] z-50 pb-safe">
      <div className="flex items-end justify-around px-2 pt-2 pb-3 max-w-screen-xl mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;

          if (item.isHero) {
            return (
              <NavLink
                key={item.id}
                to={item.path}
                className="flex flex-col items-center gap-1 group relative -mt-6"
              >
                <div className="bg-secondary rounded-full p-4 shadow-glow transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_32px_rgba(255,193,7,0.5)]">
                  <Icon className="w-7 h-7 text-secondary-foreground" strokeWidth={2.5} />
                </div>
                <span className="text-[10px] font-semibold text-secondary mt-1">
                  {item.label}
                </span>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={item.id}
              to={item.path}
              className="flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors group min-w-[60px]"
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className={cn(
                      "w-6 h-6 transition-colors",
                      isActive
                        ? "text-foreground"
                        : "text-muted-foreground group-hover:text-foreground"
                    )}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                  <span
                    className={cn(
                      "text-[10px] font-medium transition-colors",
                      isActive
                        ? "text-foreground"
                        : "text-muted-foreground group-hover:text-foreground"
                    )}
                  >
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
